function loadImage(el) {
  if (el) {
    el.addEventListener('load', function loadHandler() {
      el.removeAttribute('data-url')
      el.removeAttribute('placeholder')
      el.classList.add('loaded')
      el.removeEventListener('load', loadHandler)
    })

    el.src = el.dataset.originSrc
  }
}

function handleIntersect(entries, observer, el) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      loadImage(el)
      observer.unobserve(el)
    }
  })
}

function createObserver(el) {
  el.setAttribute('loading', 'lazy')
  const options = {
    root: null,
    threshold: '0'
  }
  const observer = new IntersectionObserver(
    (entries, obs) => handleIntersect(entries, obs, el),
    options
  )
  observer.observe(el)
}

const directives = {
  outSideClick: {
    bind: function (el, binding, vnode) {
      el.event = function (event) {
        if (!(el === event.target || el.contains(event.target))) {
          vnode.context[binding.expression](event)
        }
      }
      document.body.addEventListener('click', el.event)
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.event)
    }
  },
  lazy: {
    bind: (el, binding) => {
      const placeholder = binding.value
      if (window.IntersectionObserver && placeholder) {
        const originSrc = el.getAttribute('src')
        el.dataset.originSrc = originSrc
        el.src = placeholder
        createObserver(el)
      }
    }
  }
}

export default {
  install(Vue) {
    Object.entries(directives).forEach(([key, value]) => {
      Vue.directive(key, value)
    })
  }
}
